import { Component, Input } from '@angular/core';
import { LoadingController, NavController, ViewController } from 'ionic-angular';
import { SessionProvider } from '../../../../../providers/session/session';
import { TournamentService, PlanEnum, PlanOptions } from '../../services/tournament.service';
import { MeKoPage } from './new-plan/me-ko/me-ko';
import { PlanKoPage } from './new-plan/plan-ko/plan-ko';
import { PlanOnePage } from './new-plan/plan-one/plan-one';
import { PreRoundKoPage } from './new-plan/pre-round-ko/pre-round-ko';
import { PreRoundPage } from './new-plan/pre-round/pre-round';
import { TwoGruppeKoPage } from './new-plan/two-group-ko/two-group-ko';
import { TwoGKoPlPage } from './new-plan/twog-ko-pl/twog-ko-pl';

/**
 * Neuer Spielplan
 */

@Component({
  selector: 'new-tou-main',
  templateUrl: 'new-tou-main.html',
})
export class NewTouMainPage {
  planList = PlanOptions;

  constructor(
    private navCtrl: NavController,
    private sessionService: SessionProvider,
    private loadingCtrl: LoadingController,
    private gs: TournamentService,
    public viewCtrl: ViewController
  ) { }

  click(id: number) {
    let page = null;
    switch (id) {
      case PlanEnum.PlanOnePage: page = PlanOnePage; break;
      case PlanEnum.KoPage: page = PlanKoPage; break;
      case PlanEnum.VorPage: page = PreRoundPage; break;
      case PlanEnum.VorKoPage: page = PreRoundKoPage; break;
      case PlanEnum.GruKoPage: page = TwoGruppeKoPage; break;
      case PlanEnum.GruKoPlPage: page = TwoGKoPlPage; break;
      case PlanEnum.MePage: page = MeKoPage; break;
    };
    this.navCtrl.push(page);
  }
  dismiss(option) {
    this.viewCtrl.dismiss(option);
  }

  ionViewWillEnter() {
    // if (this.sessionService.isLoged) {
    //   let loader = this.loadingCtrl.create({});
    //   loader.present();
    //   this.gs.getPlanList().then(t => {
    //     console.log('----[NEW_PLAN_PAGE]:ionViewWillEnter-----');
    //     loader.dismiss();
    //     this.gs.$planListChangeSub.next();
    //   }).catch(e => {
    //     loader.dismiss();
    //   });
    // }
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/new-tou/new-tou-main.ts